import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import InlineValue from '../InlineValue';
import { projectTimezoneIdSelector } from '../../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../../reducers/timezones';
import { formatDate } from '../../../helpers/timezone';
// import { timeZoneHelperSelector } from '../TimeZone/TimeZoneHelpers';

const DisplaySelector = createSelector(
  [timezonesSelector, projectTimezoneIdSelector],
  (timezones, projectTimezoneId) =>  ({
    timezoneOffset: getTimezoneOffset(timezones, projectTimezoneId),
  }),
);
// export const DisplaySelector = createSelector(
//   [timeZoneHelperSelector],
//   (timeZoneHelper) => ({ timeZoneHelper }),
// );
@connect(DisplaySelector)
export default class Display extends PureComponent {
  static propTypes = {
    toggleEditor: PropTypes.func,
    value: PropTypes.string,
    userMode: PropTypes.string,
    timezoneOffset: PropTypes.number,
    // timeZoneHelper: PropTypes.object,
  };

  render() {
    const {
      toggleEditor,
      value,
      userMode,
      timezoneOffset,
      // timeZoneHelper,
    } = this.props;

    const convertedValue = formatDate(timezoneOffset, value, 'L');
    // const convertedValue = timeZoneHelper.formatDate(value, 'L');

    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {convertedValue || 'Unspecified'}
      </InlineValue>
    );

    return displayValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Date/Display.js